/* eslint-disable react/no-array-index-key */

export default function LinkLoader({ size = 4, variant = 'big' }) {
  return (
    <div role="status" className="mt-3 flex w-full flex-col gap-3">
      {[...Array(size)].map((_, index) => (
        <div
          key={index}
          className={`w-full ${
            variant === 'small' ? 'h-10' : 'h-20'
          } flex animate-pulse items-center justify-between rounded-lg bg-gray-200 px-4`}
        >
          <div className="flex h-full w-[65%] items-center gap-4 px-3 py-2">
            <div className="h-[70%] w-[40%] rounded-lg bg-gray-300" />
            <div className="flex h-full w-full flex-col justify-center gap-2">
              <div className="h-[30%] w-[80%] rounded-lg bg-gray-300" />
              <div className=" h-[30%] w-[90%] rounded-lg bg-gray-300" />
            </div>
          </div>
          <div className=" h-5 w-5 bg-gray-300" />
        </div>
      ))}
    </div>
  );
}
